import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Leadership } from './Leadership.types';

export function useLeadershipData(): Page<Leadership>['templateFields'] {
  return useCurrentPage<Page<Leadership>>().templateFields;
}
